import { getBoundingWindowWithPaddingFabric } from "@1js/window-util";

/**
 * getBoundingWindowWithPaddingFabric() in windowUtil is not properly set up to account for
 * multiple windows, and fixing it is non-trivial. For the near term, to support popouts,
 * we will instead use this function to return getBoundingWindowWithPaddingFabric for the
 * main window and 'undefined' for popouts. Fluent seems to do the right thing for popouts
 * when the value is undefined.
 */
export const getWindowBoundsFunction = (targetWindow?: Window) => {
  return targetWindow === undefined || targetWindow === window
    ? getBoundingWindowWithPaddingFabric
    : undefined;
};
